import {
  AfterViewInit,
  Component,
  HostBinding,
  Input,
  OnDestroy,
  TemplateRef,
  ViewChild,
} from '@angular/core';

import { MwFormBaseSectionComponent } from '../section-base.component';
import { MwFormDataService } from './../@services/form-data.service';

export const MwFormTitleComponentSelector = 'mw-form-title';
@Component({
  selector: MwFormTitleComponentSelector,
  templateUrl: './form-title.component.html',
})
export class MwFormTitleComponent
  implements AfterViewInit, OnDestroy, MwFormBaseSectionComponent
{
  @ViewChild(TemplateRef) templateRef: TemplateRef<any>;
  static id = 1;
  @HostBinding(`class.${MwFormTitleComponentSelector}`)
  hasHostClass = true;

  @HostBinding(`attr.id`)
  idAttr = `mw-from-title-${MwFormTitleComponent.id++}`;

  @Input()
  title: string;

  @Input()
  icon: string;

  @Input()
  subTitle: string;

  @Input()
  defaultSubTitle: string;

  @Input()
  isOutlineIcon: boolean;

  @Input()
  subTitleIndicators: string;

  @Input() orderIndex = -1;

  readonly isFormTitle = true;

  constructor(private readonly dataService: MwFormDataService) {}

  ngAfterViewInit(): void {
    this.dataService.addSection(this);
  }

  ngOnDestroy(): void {
    this.dataService.removeSection(this);
  }
}
